<template>
  <div>
    <v-layout row
              wrap>
      <v-flex xs12
              sm2>
        <v-switch v-model="isAllDay"
                  :label="$t('private_parking_products_allDay')"
                  color="primary">
        </v-switch>
      </v-flex>

      <v-layout xs10
                wrap>
        <v-flex xs12
                sm2
                offset-sm1
                v-if="!isAllDay">
          <v-menu ref="fromTime"
                  lazy
                  :close-on-content-click="false"
                  v-model="fromTimeMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  :return-value.sync="timeSelected[0]">
            <v-text-field slot="activator"
                          :label="$t('fromLabel')"
                          v-model="timeSelected[0]"
                          color="blue lighten-3"
                          prepend-icon="access_time"
                          readonly></v-text-field>
            <v-time-picker v-model="timeSelected[0]"
                           format="24hr"
                           @change="$refs.fromTime.save(timeSelected[0])"
                           @click:minute="$refs.fromTime.save(timeSelected[0])"></v-time-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12
                sm2
                offset-sm1
                v-if="!isAllDay">
          <v-menu ref="toTime"
                  lazy
                  :close-on-content-click="false"
                  v-model="toTimeMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  :return-value.sync="timeSelected[1]">
            <v-text-field slot="activator"
                          :label="$t('toLabel')"
                          v-model="timeSelected[1]"
                          color="blue lighten-3"
                          prepend-icon="access_time"
                          readonly></v-text-field>
            <v-time-picker v-model="timeSelected[1]"
                           format="24hr"
                           @change="$refs.toTime.save(timeSelected[1])"
                           @click:minute="$refs.toTime.save(timeSelected[1])"></v-time-picker>
          </v-menu>
        </v-flex>

        <v-spacer></v-spacer>

        <v-flex xs12
                sm2>
          <v-btn color="primary"
                 class="capitalize right align-self-center"
                 block
                 v-html="$t('private_parking_products_addSchedule')"
                 @click="addTimeToWeekdays"></v-btn>
        </v-flex>
      </v-layout>
    </v-layout>

    <v-layout row
              wrap
              class="gray-bg">
      <v-flex xs12>

        <el-checkbox-group v-model="checkedWeekdays"
                           size="medium">
          <v-layout v-for="weekday in weekdays"
                    :key="weekday.id"
                    row
                    style="margin:2px 0"
                    wrap>
            <v-flex xs4>
              <el-checkbox-button :label="weekday"
                                  :disabled="weekday.isDisabled"
                                  size="medium">{{weekday.label}}</el-checkbox-button>
            </v-flex>
            <v-flex xs8
                    class="text-xs-right">
              <v-chip-closable-wrapper v-for="(schedule) in weekday.schedule"
                                       :key="`$${weekday.id}_${schedule.id}`"
                                       :weekday='weekday'
                                       :schedule='schedule'
                                       class="mt-0 mb-0"
                                       @close-event="removeSchedule(weekday.id, schedule.id)">
              </v-chip-closable-wrapper>
            </v-flex>
          </v-layout>
        </el-checkbox-group>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import VChipClosableWrapper from '@/components/commons/VChipClosableWrapper';

const onWeekdayChanged = 'on-weekday-changed';

export default {
  name: 'schedule-configurator',
  components: {
    [VChipClosableWrapper.name]: VChipClosableWrapper
  },
  watch: {
    timeSelected: function(newValue) {
      if (newValue[0] === null) {
        newValue = ['00:00', '00:00'];
      }

      if (newValue[1] === null) {
        newValue[1] = newValue[0];
      }
    }
  },
  data() {
    return {
      fromTimeMenu: false,
      toTimeMenu: false,
      isAllDay: true,
      timeSelected: [moment().format('HH:mm'), moment().format('HH:mm')],
      weekdays: [],
      checkedWeekdays: [],
      from: null,
      to: null
    };
  },
  created() {
    this.init();
    EventBus.$on(keys.eventOnLanguageChanged, this.addWeekdays);
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.addWeekdays);
  },
  methods: {
    setWeekdays(weekdays) {
      this.weekdays = weekdays;
    },

    updateWeekdaysSelected(datesAvailabilityAdvanced) {
      if (this.weekdays.length === 0) {
        return;
      }

      if (datesAvailabilityAdvanced.length === 0) {
        return;
      }

      let from = moment(datesAvailabilityAdvanced[0]);
      let to = moment(datesAvailabilityAdvanced[1]).add(1, 'day');

      let index = 0;
      let tempDate = from;
      this.checkedWeekdays = [];
      let weekdaysIncluded = [];
      while (to > tempDate && index < 7) {
        let dayId = tempDate.isoWeekday();
        weekdaysIncluded.push(dayId);
        let weekDayObj = _.find(this.weekdays, itWd => {
          return itWd.id === dayId;
        });
        weekDayObj.order = index;
        weekDayObj.isDisabled = false;
        this.checkedWeekdays.push(weekDayObj);

        index++;
        tempDate = tempDate.add(1, 'days');
      }

      let weekdaysNotIncluded = _.difference([1, 2, 3, 4, 5, 6, 7], weekdaysIncluded);

      _.each(weekdaysNotIncluded, itWdNotIn => {
        let weekDayObj = _.find(this.weekdays, itWd => {
          return itWd.id === itWdNotIn;
        });
        weekDayObj.schedule = [];
        weekDayObj.isDisabled = true;
      });

      this.from = from;
      this.to = to;
    },

    init() {
      let minutes = '00';
      let dMoment = moment();
      if (dMoment.minutes() < 30) {
        minutes = '30';
      } else {
        dMoment = dMoment.add(1, 'hour');
      }

      let hour = dMoment.format('HH');

      this.isAllDay = true;
      this.timeSelected = [`${hour}:${minutes}`, `${hour}:${minutes}`];
      this.weekdays = [];
      this.checkedWeekdays = [];
      this.addWeekdays();
    },

    addWeekdays() {
      this.weekdays = [];
      this.weekdays = _.map(moment.weekdays(true), function(value, index) {
        let dayId = moment()
          .day(value)
          .isoWeekday();
        return {
          id: dayId,
          label: value,
          schedule: [],
          isDisabled: true,
          order: 0
        };
      });
    },

    addTimeToWeekdays() {
      if (this.checkedWeekdays.length === 0) {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: this.$i18n.t('private_parking_products_addSchedule.error'),
          type: 'warning',
          doNotTranslate: true
        });
        return;
      }
      this.pushWeekData();
    },

    pushWeekData() {
      let tempCheckedWeekdays = this.checkedWeekdays;

      if (this.timeSelected[0] >= this.timeSelected[1] && this.timeSelected[1] !== '00:00') {
        tempCheckedWeekdays = _.sortBy(this.checkedWeekdays, it => it.order);

        // All selected weekdays shoud have the start of the timeselected
        this.internalPushWeekData(tempCheckedWeekdays, [this.timeSelected[0], '00:00']);

        // Get Contigous weekdays of checked weekdays
        let contigousWeekdays = _.map(tempCheckedWeekdays, chWd => {
          return _.find(this.weekdays, itWd => {
            let dayId = chWd.id + 1;
            if (dayId === 8) {
              dayId = 1;
            }
            return itWd.id === dayId;
          });
        });

        this.internalPushWeekData(contigousWeekdays, ['00:00', this.timeSelected[1]]);
      } else {
        this.internalPushWeekData(tempCheckedWeekdays, this.timeSelected);
      }

      this.$emit(onWeekdayChanged, this.weekdays);
    },

    internalPushWeekData(tempCheckedWeekdays, itTimeSelected) {
      let allDay = this.isAllDay;
      _.each(tempCheckedWeekdays, (itWeekday, index) => {
        let previousRules = itWeekday.schedule;
        let startAllDay = moment('00:00', 'HH:mm');
        let endAllDay = moment('00:00', 'HH:mm').add(1, 'days');
        let textAllDay = 'private_parking_products_allDay';
        let text, s, e;

        if (allDay) {
          s = startAllDay;
          e = endAllDay;
          text = textAllDay;
        } else {
          let d = moment().format('YYYY-MM-DD');
          s = moment(`${d} ${itTimeSelected[0]}`);

          if (itTimeSelected[1] === '00:00') {
            let nextDay = moment()
              .add(1, 'days')
              .format('YYYY-MM-DD');
            e = moment(`${nextDay} ${itTimeSelected[1]}`);
          } else {
            e = moment(`${d} ${itTimeSelected[1]}`);
          }

          text = `${itTimeSelected[0]}-${itTimeSelected[1]}`;
        }

        let currentRange = moment.range(s, e);
        let toDelete = [];
        let data = {
          id: _.uniqueId(),
          text: text,
          range: currentRange,
          isAllDay: allDay
        };

        _.each(previousRules, (v, i) => {
          if (
            currentRange.overlaps(v.range, {
              adjacent: true
            })
          ) {
            let tempRange = currentRange.add(v.range);

            if (tempRange != null) {
              if (v.isAllDay) {
                tempRange = moment.range(startAllDay, endAllDay);
                data.isAllDay = v.isAllDay;
                data.text = textAllDay;
              } else {
                data.isAllDay = allDay;
                if (allDay) {
                  data.text = textAllDay;
                } else {
                  data.text = tempRange.start.format('HH:mm') + '-' + tempRange.end.format('HH:mm');
                }
              }
              data.range = tempRange;
            } else {
              if (v.isAllDay) {
                tempRange = moment.range(startAllDay, endAllDay);
                data.isAllDay = v.isAllDay;
                data.text = textAllDay;
              } else {
                data.isAllDay = allDay;
                if (allDay) {
                  data.text = textAllDay;
                } else {
                  let startDate = currentRange.start;
                  if (v.range.start < currentRange.start) {
                    startDate = v.range.start;
                  }
                  let endDate = currentRange.end;
                  if (v.range.end > currentRange.end) {
                    endDate = v.range.end;
                  }
                  tempRange = moment.range(startDate, endDate);
                  data.text = startDate.format('HH:mm') + '-' + endDate.format('HH:mm');
                }
              }
              data.range = tempRange;
            }
            toDelete.push(v.id);
          }
        });

        _.remove(previousRules, function(v) {
          let exists = _.find(toDelete, function(id) {
            return v.id === id;
          });
          return typeof exists !== 'undefined';
        });

        previousRules.push(data);

        itWeekday.schedule = _.sortBy(previousRules, function(it) {
          return it.range.start;
        });
      });
    },

    removeSchedule(weekdayId, scheduleId) {
      let weekday = _.find(this.weekdays, weekday => {
        return weekday.id === weekdayId;
      });

      let cloneSchedule = _.cloneDeep(weekday.schedule);

      _.remove(cloneSchedule, schedule => {
        return schedule.id === scheduleId;
      });

      this.$nextTick(() => {
        weekday.schedule = cloneSchedule;

        this.$emit(onWeekdayChanged, this.weekdays);

        this.$forceUpdate();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.gray-bg {
  background-color: #f5f5f5;
}

.el-checkbox-group {
  font-size: 14px;
}

.el-date-editor {
  width: 92px;
}

.el-row.row-form {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>

<style>
.el-checkbox-button__inner {
  width: 150px;
}

.el-tag.el-tag--info {
  width: 100px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/ScheduleConfigurator.vue